
import { useEffect } from 'react'
import Select from 'react-select'
import { GardenDDLAPI, SectorDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const GardenNameDDL = (props) => {
    const { GardenName, setGardenName, SectorName, WardName, IsDisabled, APIFlag, Asset, AssetType, isLabel=false } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WardID: WardName?.ID,
            M_GD_SectorID: SectorName?.ID,

            M_AssetID: Asset ?? 0,
            M_AssetTypeID: AssetType ?? 0,
            APIFlag: APIFlag ?? '',

            UserID: UserID,
            token: token,
            handleSectorDDL: handleSectorDDL
        }
        if (WardName?.ID != 0 || SectorName?.ID != 0) {
            dispatch(GardenDDLAPI({ data }))
        }
    }, [WardName?.ID, SectorName?.ID, AssetType, Asset, isLabel])

    // const { DDLData } = useSelector(state => state.GardenDDLData)


    const handleSectorDDL = (DDLData) => {
        if (DDLData && DDLData.table && DDLData.table.length > 0) {
            let list = DDLData.table.map((item, index) => ({
                value: item.m_AssetID,
                label: item.assetName,
            }))
            setGardenName({ ...GardenName, DDL: list })
        }
        else {
            setGardenName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (

        <div className="form-group">
            {
                !isLabel &&
                    <label className="d-block" htmlFor="NameofDepartment"><b>Garden Name</b></label>
            }
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable
                isDisabled={IsDisabled}
                maxMenuHeight={150}
                value={{ value: GardenName.ID, label: GardenName.Label }}
                onChange={(e) => {
                    e ?
                        setGardenName({ ...GardenName, ID: e.value, Label: e.label })
                        :
                        setGardenName({ ...GardenName, ID: 0, Label: "Select..." })

                }}
                options={GardenName.DDL}
            />
        </div>
    )
}